import { Tooltip } from 'antd';
import ButtonIcon from 'base/ui/components/Button/buttonIcon';
import { PencilEdit, SynchronizeArrows, Trash } from 'base/ui/components/Icons';
import { forwardRef } from 'react';

export type Ref = HTMLButtonElement;

const ButtonEdit = forwardRef<Ref, React.ButtonHTMLAttributes<HTMLButtonElement>>(
  (props: React.ButtonHTMLAttributes<HTMLButtonElement>, ref) => {
    return (
      <Tooltip title={'Sửa'}>
        <ButtonIcon ref={ref} {...props} color="#007aee">
          <PencilEdit width="13" height="13" className="!fill-[#007aee]" />
        </ButtonIcon>
      </Tooltip>
    );
  },
);
const ButtonDelete = forwardRef<Ref, React.ButtonHTMLAttributes<HTMLButtonElement>>(
  (props: React.ButtonHTMLAttributes<HTMLButtonElement>, ref) => {
    return (
      <Tooltip title={'Xóa'}>
        <ButtonIcon ref={ref} {...props} color="#ff5448">
          <Trash width="13" height="13" className="!fill-[#ff5448]" />
        </ButtonIcon>
      </Tooltip>
    );
  },
);
const ButtonNonActive = forwardRef<Ref, React.ButtonHTMLAttributes<HTMLButtonElement>>(
  (props: React.ButtonHTMLAttributes<HTMLButtonElement>, ref) => {
    return (
      <Tooltip title={'Ngưng hoạt động'}>
        <ButtonIcon ref={ref} {...props} color="#1a8ba3">
          <SynchronizeArrows width="13" height="13" className="!fill-[#1a8ba3]" />
        </ButtonIcon>
      </Tooltip>
    );
  },
);




export { ButtonDelete, ButtonEdit, ButtonNonActive };

